import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { DubaiPin } from "../../../../app-constants";
import FaqComponents from "../../components/common/faq";
import BgImg from "../../../images/locationgcc/game/faq_bg.webp";

const faqs = [
  {
    question:
      "What makes your mobile game development company in Dubai different from the competition?",
    answer: ` <p>Our team merges modern and novel design, leading-edge technology, and a profound understanding of the local market to offer customized mobile games that stand out in Dubai's competitive world.</p>`,
  },
  {
    question:
      " How long does the mobile game development procedure naturally take?",
    answer: `  <p>The timeline changes based on the difficulty of the game. On average, our game development ventures are completed within a few months, warranting a balance between effectiveness and high-quality development.</p>`,
  },
  {
    question: "Can you craft games for both iOS and Android platforms?",
    answer: ` <p>Yes. We are expert in cross-platform development, crafting engaging games that impeccably work on both iOS and Android devices for maximum downloads and engagement.</p>`,
  },
  {
    question: " What kind of game types do you specialize in?",
    answer: `<p>Our proficiency extents a broad range of game types, from casual and arcade to simulation and strategy. We modify our methods to match the exclusive vision and objectives of each client.</p>`,
  },
  {
    question: "How much will I be involved in the development process?",
    answer: `<p>We promote transparent communication and partnership between our clients and business analysts and strategists. You'll receive regular updates, milestone evaluations, and opportunities to offer feedback during the complete development journey.</p>`,
  },
  {
    question: "Do you offer post-launch support and updates?",
    answer: `<p>Absolutely. Our commitment encompasses launch day and as long as our client desires to our services. We provide post-launch support, resolving any problems, applying updates, and guaranteeing your game grows to meet varying market demands.</p>`,
  },
  {
    question:
      " What is the cost structure for mobile game development company services?",
    answer: `<p>Costs change based on project difficulty. We offer transparent pricing models, providing suppleness to lodge different budget ranges while warranting the delivery of a high-quality mobile game.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center top",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>
                Game Development Dubai <span>FAQs</span>
              </h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>

          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{DubaiPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
